//Core Modules
import React from "react";

//External Modules
import cx from "classnames";

//custom modules
import {randstr} from "../../Common/Appcommon";
import {useStepsContext} from "./context/stepsContext";

const SubscriptionSteps = ({steps, currentStep, wrapperClass=''}) => {

    const {
        setCurrentStep,
        resetSubscriptionInfo,
        isPricingUpdate
    } = useStepsContext();

    const handleStepsClick = (step) => {

        let valid = true;

        //don't allow to go back when complete page reached.
        if(currentStep === 4){
            valid = false;
        }

        //don't allow to select plan while updating pricing.
        if(step === 1 && isPricingUpdate){
            valid = false;
        }

        if(valid){
            if(step === 1){
                resetSubscriptionInfo();
            }
            setCurrentStep(step);
        }
    }

    return(
        <div className={`import-steps w-100 text-center`}>
            <div className={`import-stage-wrapper ${wrapperClass}`}>
                <ul className={`stage-lists-container`}>
                    {
                        steps.map((value,index) => {

                            const val = index + 1;
                            const isCompleted = Number(currentStep) > val;
                            const isCurrent = (currentStep === val);

                            return (
                                <li key={randstr('step_list_')} className={cx(`stage-list`,{
                                    "currentview" : isCurrent,
                                    "selected-menu" : Number(currentStep) > val
                                })} onClick={isCompleted ? ()=> {handleStepsClick(val)} : ()=>{}}>
                                    <div>
                                        <span className={`bold`}>{value}</span>
                                    </div>
                                </li>
                            );

                        })
                    }
                </ul>
            </div>
        </div>
    );
}

export default SubscriptionSteps;